import React, { useState, useEffect } from 'react';
import '../../assets/styles/Timer.css'
import RightArrow from '../../assets/images/svg/Right arrow.svg';

const Timer = ({onEnrollClick}) => {
  // Set your deadline
  const deadline = new Date('2025-10-10T23:59:59'); 
      const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // smooth scroll
    });
  };
  const calculateTimeLeft = () => {



    const now = new Date();
    const difference = deadline - now;

    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    } else {
      timeLeft = null; 
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  if (!timeLeft) {
    return <div className="timer-up">Deadline Reached!</div>;
  }

  return (
    <div className="timer-container">
      <h2>Deadline To Enroll: <span>October 10, 2025</span></h2>
      <div className="timer">
        <div className="timer-item">
          <span>{timeLeft.days}</span>
          <small>Days</small>
        </div>
        <div className="timer-item">
          <span>{timeLeft.hours}</span>
          <small>Hours</small>
        </div>
        <div className="timer-item">
          <span>{timeLeft.minutes}</span>
          <small>Minutes</small>
        </div>
        <div className="timer-item">
          <span>{timeLeft.seconds}</span>
          <small>Seconds</small>
        </div>
      </div>
         <p className="timer-intern"><span>*</span>500 Internship Positions Only</p>

            <ul>
              <li>Limited openings only. First come first serve basis. </li>
               <li>The students will upload their profile along with their pitch deck and the companies will choose the best according to their requirements.</li>
                <li>The students can also view the opportunities and apply to the openings that they are interested in..  </li>
            </ul>


                 {/* <div className="landing-cta-button" onClick={onEnrollClick}> */}

                  <div
    className="landing-cta-button"
    onClick={() => {
      if (onEnrollClick) onEnrollClick(); // optional callback
      window.open("https://ariseforyou.com/register", "_blank"); // opens in new tab
    }}
  >
          <p className="mb-0 txt-white font-regular-four txt-size">Enroll Now</p>
          <img src={RightArrow} alt="Right Arrow" className="landing-cta-button-arrow" />
        </div>
    </div>
  );
};

export default Timer;
